export default __webpack_public_path__ + "static/media/mag-logo.f7668c4e.png";